/*
 * #/editor — the miniPaint editor, embedded in a same-origin iframe.
 *
 * The iframe is the editor's UI *and* the shared document: whatever the human does
 * here is the state an agent inspects, and vice versa. Tools are registered by the
 * top-level page (ChatGPT does not see tools registered inside a frame), so this
 * component's only job is to mount the frame and hand it to the EditorHost.
 */

import React, { useEffect, useRef, useState } from 'react'
import { editorHost, EditorState } from '../editor/editorHost.js'

const banner = {
  position: 'absolute',
  top: 8,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  padding: '8px 12px',
  borderRadius: 6,
  boxShadow: '0 1px 4px rgba(0,0,0,.25)',
  fontSize: 13,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace'
}

export const Editor = () => {
  const frameRef = useRef(null)
  const [status, setStatus] = useState(() => editorHost.status())

  useEffect(() => {
    const off = editorHost.subscribe(setStatus)
    if (frameRef.current) {
      editorHost.attach(frameRef.current).catch(() => { /* surfaced through status */ })
    }
    return off
  }, [])

  return (
    <div
      style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', background: '#fff' }}
      data-testid='editor-page'
    >
      {status.state === EditorState.LOADING && (
        <div style={{ ...banner, background: '#fdf3d8', color: '#854d0e' }} data-testid='editor-loading'>
          {status.slow
            ? 'Still loading the miniPaint editor — a cold CDN cache fetches ~40 icon files. This resolves itself.'
            : 'Loading the miniPaint editor…'}
        </div>
      )}
      {status.state === EditorState.FAILED && (
        <div style={{ ...banner, background: '#fde2e2', color: '#991b1b' }} data-testid='editor-error'>
          {status.error}
        </div>
      )}
      <iframe
        ref={frameRef}
        data-testid='minipaint-frame'
        id='minipaint-frame'
        title='miniPaint editor'
        src='./minipaint/index.html'
        style={{ flex: 1, width: '100%', border: 0, display: 'block', background: '#fff' }}
      />
    </div>
  )
}

export default Editor
